// app/store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

// Static reducers (needed so combineReducers is never empty)
const staticReducers = {
  _placeholder: (state = {}) => state,
};

const sagaMiddleware = createSagaMiddleware();

export const createReducer = (asyncReducers = {}) =>
  combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });

// Create store
export const store = configureStore({
  reducer: createReducer(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
});

// Track async reducers
store.asyncReducers = {};

// Function to inject reducers dynamically
store.injectReducer = (key, reducer) => {
  if (!store.asyncReducers[key]) {
    store.asyncReducers[key] = reducer;
    store.replaceReducer(createReducer(store.asyncReducers));
  }
};

// Track injected sagas
const injectedSagas = {};
store.runSaga = sagaMiddleware.run;

// Function to inject sagas dynamically
store.injectSaga = (key, saga) => {
  if (!injectedSagas[key]) {
    injectedSagas[key] = sagaMiddleware.run(saga);
  }
};
